<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->


<template>

    <div class="sdev-sidebar-runtime">

        <BedrockMonitor variant="stack" :auto="true" class="compact" />
        <div class="sdev-systembar-status">

            <span v-if="navigationState.source === 'fallback'" class="sdev-systembar-indicator-unhealthy">
                Navigation in fallback mode
            </span>

            <span v-else class="sdev-systembar-indicator-healthy">
                System healthy
            </span>
        </div>

        <div class="sdev-systembar-tools">
            <button class="sdev-systembar-toggle" @click="toggle">
                ⚙
            </button>

        </div>
    </div>

</template>


<script setup>

defineOptions({
    name: "SidebarRuntime"
})

defineProps({
    open: Boolean
})
import BedrockMonitor from "@/reflection/Core/BedrockMonitor.vue"
import { navigationState } from "@/domain/navigation/navigation.state"
/*
────────────────────────────────────────
TAB IDENTIFIER
────────────────────────────────────────
Each browser tab gets a stable ID.
Useful for:

- Websocket channels
- Tab coordination
- Debugging
*/

function getTabId() {

    if (!window.name) {
        window.name = `tab-${Math.random().toString(36).slice(2, 6)}`
    }

    return window.name
}


/*
────────────────────────────────────────
RUNTIME INFO
────────────────────────────────────────
Static runtime data from build environment.
*/

const runtime = {

    version: import.meta.env.VITE_APP_VERSION || "0.0.0",

    build: import.meta.env.VITE_APP_BUILD || "dev",

    env: import.meta.env.VITE_APP_ENV || "local",

    tabId: getTabId()

}

</script>